import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './icon__question-small.scss';

const IconQuestionSmall = ({ mix, ...props }) => (
    <svg
        className={cx(b('icon', 'question-small'), mix)}
        height="10"
        viewBox="-1 0 8 10"
        width="8"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g className="icon__question-elem" fillRule="evenodd">
            <path d="M5.44 4.445C4.763 5.032 3.527 4.98 3.855 6c.143.448-.328.906-.847.906-.518 0-.946-.395-.946-.906 0-.734.538-1.307 1.158-1.555 1.228-.452 1.427-.995 1.427-1.408 0-.646-.792-1.04-1.66-1.04-.715 0-1.693.632-2.151 1.138L.459 1.998C1.384.598 4.17.412 5.325 1.474c1.155 1.062.79 2.385.114 2.971zM2.994 10a.956.956 0 0 1-.393-.082.98.98 0 0 1-.528-.54A1.015 1.015 0 0 1 2 8.993c0-.277.094-.512.282-.705A.952.952 0 0 1 2.994 8c.286 0 .525.096.718.29A.96.96 0 0 1 4 8.993a.947.947 0 0 1-.08.383 1.018 1.018 0 0 1-.534.54.956.956 0 0 1-.392.083z" />
        </g>
    </svg>
);

IconQuestionSmall.propTypes = {
    mix: PropTypes.string,
};

export default IconQuestionSmall;
